import { OnInit, Component, EventEmitter, Input, Output, ChangeDetectorRef,ViewChild } from "@angular/core";
import { ApiRequest,IApiresponse } from "src/app/_models";
import { SelectCompanyPopupModel,SelectCompanyModel } from "src/app/_models/claimant-on-web/claimant-on-web";
import { MultipleCompaniesService } from 'src/app/_services/multiple-companies/multiple-companies.service';
import { CompanyCardAccessGrantDetail,
    CompanyCardAccessGrantDetailResponse, 
    DetailsForCompanyCardAccessGrantRequest,SaveCompanyCardAccessGrantsRequest } from 'src/app/_models/multiple-companies/multiple-companies';
import { TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { Claims } from "src/app/_models/common/claims";
import { Subscription } from "rxjs";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { DynamicFormComponent } from "src/app/shared/forms/dynamic-form/dynamic-form.component";
import { DynamicFormService } from "src/app/shared/forms/dynamic-form/dynamic-form.service";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "select-company-panel",
    templateUrl: "./select-company-panel.component.html",
    standalone: false
})
export class SelectCompanyPanelComponent implements OnInit {
    @ViewChild(DynamicFormComponent) ccForm: DynamicFormComponent;

    @Input()
    inputData: SelectCompanyPopupModel;

    @Output() closePanelEvent = new EventEmitter<boolean>();
    @Output() selectItemEvent = new EventEmitter<SelectCompanyPopupModel>();

    searchText: string = '';
    param: any;
    claimsSubscription: Subscription;
    userActionEventSubscription: Subscription;
    claims: Claims;

    companyList = <CompanyCardAccessGrantDetail[]>[];
    selectedCompanyId: number = 0;

    showSendRequestPanel: boolean = false;
    showJustificationPanel: boolean = false;

    ccFormModel: SelectCompanyModel;
    ccFormFields: FormlyFieldConfig[] = [];
    selectedItem: CompanyCardAccessGrantDetail;

    constructor(
         private multipleCompaniesService: MultipleCompaniesService,
         private translate: TranslateService,
         private claimsService: ClaimsService,
         private dynamicFormService: DynamicFormService,
         private toastr: ToastrService,
         private cd:ChangeDetectorRef) {
            this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });
    }

    ngOnInit(): void {
        this.fnGetCompanyList();
    }

    fnClosePanel() {
        this.closePanelEvent.emit(true);
    }
    fnGetCompanyList() {
        let request = new ApiRequest<DetailsForCompanyCardAccessGrantRequest>("GetCompanyCardAccessGrantDetailList", environment.applicationVersion, environment.requestId);

        let requestInfo = new DetailsForCompanyCardAccessGrantRequest();
        requestInfo.organisationId = this.claims.OrgId;
        requestInfo.userId = this.inputData.claimantId;
        request.requestInfo = requestInfo;

        this.multipleCompaniesService.GetCompanyCardAccessGrantDetailList(request)
            .subscribe((response: IApiresponse<CompanyCardAccessGrantDetailResponse>) => {
                if (response.responseInfo != null) {
                    this.companyList = response.responseInfo.companyList;            
                    this.fnGetSelectedValueOnTop();
                }
            });
    }

    fnSelectCompany(item: CompanyCardAccessGrantDetail) {
        if (item) {
            if(item.isAccessAssigned){
                 this.selectedItem = item;

                 if(this.inputData.cardCompanyId > 0 && item.companyId != this.inputData.cardCompanyId && item.isJustificationRequired){
                     this.fnShowJustificationPanel();
                   }
                 else{
                     this.fnBindCompanyOutputModel(null);
                 }  
            }
        }
    }

    fnBindCompanyOutputModel(justificationNotes: any){
         let selectCompanyOutputModel = new SelectCompanyPopupModel();
         selectCompanyOutputModel.companyId = this.selectedItem.companyId;
         selectCompanyOutputModel.companyName = this.selectedItem.companyName;
         selectCompanyOutputModel.companyJustificationNotes = justificationNotes ? justificationNotes : "";
         this.selectItemEvent.emit(selectCompanyOutputModel);
    }

    fnSetCompanyInputValues() {
        if (this.inputData) {
            this.selectedCompanyId = this.inputData.companyId;
        }
    }

    fnGetSelectedValueOnTop() {
      let companyId = this.inputData?.companyId ?? 0;

        if (Array.isArray(this.companyList) && this.companyList.length > 0) {
            this.companyList.sort((a, b) => {
                const aMatch = a.isAccessAssigned;
                const bMatch = b.isAccessAssigned;

                return aMatch === bMatch ? 0 : aMatch ? -1 : 1;
            });

            if(companyId > 0){
                    this.companyList.sort((a, b) => {
                const aMatch = a.companyId === companyId;
                const bMatch = b.companyId === companyId;

                return aMatch === bMatch ? 0 : aMatch ? -1 : 1;
            });
            }
       
         }
        this.cd.detectChanges();
    }

    fnShowSendRequestPanel(item: any){
        this.selectedItem = item;
        this.showSendRequestPanel = true;
    }

    fnCloseSendRequestPanel(){
        this.selectedItem = null;
        this.showSendRequestPanel = false;
    }

    fnShowJustificationPanel(){
        this.showJustificationPanel = true;
        this.fnInitializeForm();
    }

     fnCloseJustificationPanel(){
        this.showJustificationPanel = false;
    }

    fnInitializeForm() {
        this.ccFormModel = new SelectCompanyModel();
        this.ccFormModel.companyJustificationNotes = "";

        let fields: FormlyFieldConfig[] = [];

        fields.push({
            fieldGroupClassName: 'block row',
            fieldGroup: [
                {
                    key: 'companyJustificationNotes',
                    type: 'text-input',
                    className: 'col-xl-12 col-lg-12 col-md-12 col-sm-12 padding-left-3 highlight-border pills-change-password',
                    templateOptions: {
                        label: this.translate.instant('Enter Justification Notes'),
                        placeholder: '',
                        required: true,
                        omitSpecialChar: false,
                        customErrors: [],
                        maxLength: 200,
                        maxLengthCount: true,
                    },
                    validators: {
                        validation: ['whitespace']
                    }
                }
            ]
        });

        this.ccFormFields = fields;

    }

    fnSaveJustificationNotes(){

        if(this.ccForm.form.invalid){

           return;
        }
        else{
            this.fnBindCompanyOutputModel(this.ccFormModel.companyJustificationNotes);
        }
    }

    fnSendCompanyCardAccessGrantRequest(){
        let request = new ApiRequest<SaveCompanyCardAccessGrantsRequest>("SendCompanyCardAccessGrantRequest", environment.applicationVersion, environment.requestId);

        let requestInfo = new SaveCompanyCardAccessGrantsRequest();
        requestInfo.organisationId = this.claims.OrgId;
        requestInfo.userId = this.inputData.claimantId;
        requestInfo.companyId = this.selectedItem.companyId;
        requestInfo.updatedBy = this.claims.UserId;
        requestInfo.userName = this.claims.FinanceManager;
        request.requestInfo = requestInfo;

        this.multipleCompaniesService.SendCompanyCardAccessGrantRequest(request)
            .subscribe((response: IApiresponse<any>) => {
                if (response.responseInfo != null) {
                      this.toastr.success(this.translate.instant("success"));
                      this.selectedItem = null;
                      this.fnCloseSendRequestPanel();
                      this.fnGetCompanyList();
                }
            });
    }

}
